"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));
var _replaceAll = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/replace-all"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _BouncerProvider = _interopRequireDefault(require("@/libs/BouncerProvider"));
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _fingerprintjs = _interopRequireDefault(require("@fingerprintjs/fingerprintjs"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var log = _Logger.default.namespace('Welcome.vue');
var _default = exports.default = {
  components: {
    Captcha: _Captcha.default,
    StartupLayout: _CommonLayout.default
  },
  data: function data() {
    return {
      connectErrors: [],
      network: null,
      channel: '',
      nick: '',
      password: '',
      showChannel: true,
      showPass: true,
      toggablePass: true,
      showNick: true,
      show_password_box: false,
      connectWithoutChannel: false,
      showPlainText: false,
      captchaReady: false,
      termsAccepted: false
    };
  },
  computed: {
    isIframe: function isIframe() {
      return !(window === window.parent || window.opener);
    },
    startupOptions: function startupOptions() {
      return this.$state.settings.startupOptions;
    },
    greetingText: function greetingText() {
      var greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    footerText: function footerText() {
      var footer = this.$state.settings.startupOptions.footerText;
      return typeof footer === 'string' ? footer : '';
    },
    termsContent: function termsContent() {
      var terms = this.$state.settings.startupOptions.termsContent;
      return typeof terms === 'string' ? terms : '';
    },
    buttonText: function buttonText() {
      var greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    buttonTextLogin: function buttonTextLogin() {
      return 'Iniciar sesión';
    },
    buttonTextRegister: function buttonTextRegister() {
      return 'Registrarse';
    },
    isNickValid: function isNickValid() {
      var nickPatternStr = this.$state.setting('startupOptions.nick_format');
      var nickPattern = '';
      if (!nickPatternStr) {
        // Nicks cannot start with [0-9- ]
        // ? is not a valid nick character but we allow it as it gets replaced
        // with a number.
        nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
      } else {
        // Support custom pattern matches. Eg. only '@example.com' may be allowed
        // on some IRCDs
        var pattern = '';
        var flags = '';
        if (nickPatternStr[0] === '/') {
          // Custom regex
          var pos = nickPatternStr.lastIndexOf('/');
          pattern = nickPatternStr.substring(1, pos);
          flags = nickPatternStr.substr(pos + 1);
        } else {
          // Basic contains rule
          pattern = _lodash.default.escapeRegExp(nickPatternStr);
          flags = 'i';
        }
        try {
          nickPattern = new RegExp(pattern, flags);
        } catch (error) {
          log.error('Nick format error: ' + error.message);
          return false;
        }
      }
      return this.nick.match(nickPattern);
    },
    readyToStart: function readyToStart() {
      var ready = !!this.nick;
      if (!this.connectWithoutChannel && !this.channel) {
        ready = false;
      }

      // Make sure the channel name starts with a common channel prefix
      if (!this.connectWithoutChannel) {
        var bufferObjs = Misc.extractBuffers(this.channel);
        bufferObjs.forEach(function (bufferObj) {
          if ('#&'.indexOf(bufferObj.name[0]) === -1) {
            ready = false;
          }
        });
      }

      // If toggling the password is is disabled, assume it is required
      if (!this.toggablePass && !this.password) {
        ready = false;
      }
      if (!this.isNickValid) {
        ready = false;
      }
      if (this.termsContent && !this.termsAccepted) {
        ready = false;
      }
      return ready;
    }
  },
  watch: {
    show_password_box: function show_password_box(newVal) {
      if (newVal === false) {
        // clear the password when show password is unchecked
        this.password = '';
      }
    }
  },
  created: function created() {
    var _context,
      _this = this;
    this.$state.$emit('metrics.landing');
    var options = this.startupOptions;
    var connectOptions = this.connectOptions();
    var token = this.$state.settings.chatea_options.token || this.$state.settings.chatea_options.access_token;

    // Take some settings from a previous network if available
    var previousNet = null;
    if ((0, _trim.default)(_context = connectOptions.hostname).call(_context)) {
      var _context2;
      previousNet = this.$state.getNetworkFromAddress((0, _trim.default)(_context2 = connectOptions.hostname).call(_context2));
    }
    if (previousNet && previousNet.connection.nick) {
      this.nick = previousNet.connection.nick;
    } else if (Misc.queryStringVal('nick')) {
      this.nick = Misc.queryStringVal('nick');
    } else {
      this.nick = options.nick;
    }
    this.nick = this.processNickRandomNumber(this.nick || '');
    if (options.password) {
      this.password = options.password;
    } else if (previousNet && previousNet.password) {
      this.password = previousNet.password;
      this.show_password_box = true;
    } else {
      this.password = '';
    }
    this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
    this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
    this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
    this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
    this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;
    this.connectWithoutChannel = !!options.allowNoChannel;
    this.channel = this.$state.settings.chatea_options.channel || options.channel || '';
    if (this.$state.settings.chatea_options.nick != null) {
      this.nick = this.$state.settings.chatea_options.nick;
    }
    var showPassword = this.$state.settings.chatea_options.show_password_box === 'true' || false;
    this.show_password_box = showPassword;
    if (token) {
      this.$state.$emit('auth.restore', {
        kind: 'portal',
        surface: 'startup'
      });
      var parseJwt = this.parseJwt(token);
      this.nick = parseJwt.name || '';
      this.$state.settings.startupOptions.autoConnect = true;
    }
    if (options.bouncer) {
      this.toggablePass = false;
      this.showPass = true;
      this.showChannel = false;
      this.connectWithoutChannel = true;
      var bouncer = new _BouncerProvider.default(this.$state);
      bouncer.enable(connectOptions.hostname, connectOptions.port, connectOptions.tls, connectOptions.direct, connectOptions.direct_path);
    }
    var fpPromise = _fingerprintjs.default.load();
    (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
      var fp, result, getStoredVisitorId, visitorId, _context3, date, expires, domain;
      return _regenerator.default.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            getStoredVisitorId = function _getStoredVisitorId() {
              function getCookie(name) {
                var value = "; ".concat(document.cookie);
                var parts = value.split("; ".concat(name, "="));
                if (parts.length === 2) return parts.pop().split(';').shift();
                return null;
              }

              // 1. Check Cookie
              var cookieVal = getCookie('visitorId');
              if (cookieVal) {
                return cookieVal;
              }

              // 2. Check LocalStorage
              var localVal = localStorage.getItem('visitorId');
              if (localVal) {
                return localVal;
              }
              return null;
            };
            _context4.next = 1;
            return fpPromise;
          case 1:
            fp = _context4.sent;
            _context4.next = 2;
            return fp.get();
          case 2:
            result = _context4.sent;
            visitorId = getStoredVisitorId();
            if (visitorId == null) {
              // 1. Set Cookie
              date = new Date();
              date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
              expires = 'expires=' + date.toUTCString();
              domain = '.' + (0, _slice.default)(_context3 = window.location.hostname.split('.')).call(_context3, -2).join('.');
              document.cookie = 'visitorId=' + result.visitorId + ';' + expires + ';path=/;domain=' + domain;

              // 2. Set LocalStorage
              localStorage.setItem('visitorId', result.visitorId);
              visitorId = result.visitorId;
            }
            _this.$state.settings.chatea_options.visitorId = visitorId;
            if (options.autoConnect && _this.readyToStart) {
              _this.startUp();
            }
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    onAltClose: function onAltClose(event) {
      if (event.channel) {
        this.channel = event.channel;
      }
      if (event.nick) {
        this.nick = event.nick;
      }
      if (event.password) {
        this.password = event.password;
      }
      if (event.error) {
        this.connectErrors.push(event.error);
      }
      this.$state.settings.startupOptions.altComponent = null;
    },
    parseJwt: function parseJwt(token) {
      var _context5;
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent((0, _map.default)(_context5 = window.atob(base64).split('')).call(_context5, function (c) {
        var _context6;
        return '%' + (0, _slice.default)(_context6 = '00' + c.charCodeAt(0).toString(16)).call(_context6, -2);
      }).join(''));
      return JSON.parse(jsonPayload);
    },
    clearUrlParams: function clearUrlParams() {
      var url = new _url.default(window.location.href);
      url.search = ''; // Elimina los query params
      url.hash = ''; // Elimina los hash params
      window.history.replaceState({}, document.title, url.toString());
    },
    goLogin: function goLogin() {
      var _context7;
      this.$state.$emit('metrics.login_click', {
        kind: 'login',
        surface: 'startup'
      });
      this.$state.$emit('auth.attempt', {
        kind: 'login',
        surface: 'startup'
      });
      this.clearUrlParams(); // Llama a la función para limpiar la URL
      var redirect = this.$state.settings.chatea_options.loginBaseUrl + '/login/oauth/authorize?client_id=' + this.$state.settings.chatea_options.clientId + '&response_type=token&redirect_uri=' + window.location.href + encodeURIComponent('?channel=' + (0, _replaceAll.default)(_context7 = this.channel).call(_context7, '#', ''));
      window.location.href = redirect;
    },
    goRegister: function goRegister() {
      var _context8;
      this.$state.$emit('metrics.login_click', {
        kind: 'signup',
        surface: 'startup'
      });
      this.$state.$emit('auth.attempt', {
        kind: 'signup',
        surface: 'startup'
      });
      this.clearUrlParams(); // Llama a la función para limpiar la URL
      var redirect = this.$state.settings.chatea_options.loginBaseUrl + '/signup/oauth/authorize?client_id=' + this.$state.settings.chatea_options.clientId + '&response_type=token&redirect_uri=' + window.location.href + encodeURIComponent('?channel=' + (0, _replaceAll.default)(_context8 = this.channel).call(_context8, '#', ''));
      window.location.href = redirect;
    },
    readableStateError: function readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit: function formSubmit() {
      this.$state.$emit('metrics.start', {
        kind: 'guest',
        allowed: !!this.readyToStart
      });
      if (this.readyToStart) {
        this.startUp();
      }
    },
    startUp: function startUp() {
      var _this2 = this;
      this.connectErrors = [];
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = this.connectOptions();
      var netAddress = (0, _trim.default)(_lodash.default).call(_lodash.default, connectOptions.hostname);

      // Check if we have this network already
      var net = this.network || this.$state.getNetworkFromAddress(netAddress);
      var password = this.password;
      this.$state.settings.chatea_options.password = this.password;
      if (this.$state.settings.chatea_options.nick == null) {
        this.$state.settings.chatea_options.nick = this.nick;
      }

      // If the network doesn't already exist, add a new one
      net = net || this.$state.addNetwork('Network', this.nick, {
        server: netAddress,
        port: connectOptions.port,
        tls: connectOptions.tls,
        password: password,
        encoding: (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding),
        direct: connectOptions.direct,
        path: connectOptions.direct_path || '',
        gecos: options.gecos,
        username: this.$state.settings.chatea_options.visitorId || options.username
      });

      // Clear the server buffer in case it already existed and contains messages relating to
      // the previous connection, such as errors. They are now redundant since this is a
      // new connection.
      net.serverBuffer().clearMessages();

      // If we retreived an existing network, update the nick+password with what
      // the user has just put in place
      net.connection.nick = this.nick;
      if (options.bouncer) {
        var _context9;
        // Bouncer mode uses server PASS
        net.connection.password = (0, _concat.default)(_context9 = "".concat(this.nick, ":")).call(_context9, password);
        net.password = '';
      } else {
        net.connection.password = '';
        net.password = password;
      }
      if ((0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding || '')) {
        net.connection.encoding = (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding);
      }
      this.network = net;

      // Only switch to the first channel we join if multiple are being joined
      var hasSwitchedActiveBuffer = false;
      var bufferObjs = Misc.extractBuffers(this.channel);
      bufferObjs.forEach(function (bufferObj) {
        var newBuffer = _this2.$state.addBuffer(net.id, bufferObj.name);
        newBuffer.enabled = true;
        if (newBuffer && !hasSwitchedActiveBuffer) {
          _this2.$state.setActiveBuffer(net.id, newBuffer.name);
          hasSwitchedActiveBuffer = true;
        }
        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }
      });

      // switch to server buffer if no channels are joined
      if (!options.bouncer && !hasSwitchedActiveBuffer) {
        this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
      }
      net.ircClient.connect();
      var _onRegistered = function onRegistered() {
        if (_this2.$refs.layout) {
          _this2.$refs.layout.close();
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var _onClosed = function onClosed() {
        var _context0;
        var lastError = _this2.network.last_error;
        if (lastError && !(0, _includes.default)(_context0 = _this2.connectErrors).call(_context0, lastError)) {
          _this2.connectErrors.push(lastError);
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var onError = function onError(event) {
        var _context1;
        if (!event.reason || (0, _includes.default)(_context1 = _this2.connectErrors).call(_context1, event.reason)) {
          return;
        }
        _this2.connectErrors.push(event.reason);
      };
      net.ircClient.once('registered', _onRegistered);
      net.ircClient.once('close', _onClosed);
      net.ircClient.on('irc error', onError);
    },
    processNickRandomNumber: function processNickRandomNumber(nick) {
      // Replace ? with a random number
      var tmp = (nick || '').replace(/\?/g, function () {
        return Math.floor(Math.random() * 100).toString();
      });
      return (0, _trim.default)(_lodash.default).call(_lodash.default, tmp);
    },
    handleCaptcha: function handleCaptcha(isReady) {
      this.captchaReady = isReady;
    },
    connectOptions: function connectOptions() {
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = Misc.connectionInfoFromConfig(options);

      // If a server isn't specified in the config, set some defaults
      // The webircgateway will have a default network set and will connect
      // there instead. This just removes the requirement of specifying the same
      // irc network address in both the server-side and client side configs
      connectOptions.hostname = connectOptions.hostname || 'default';
      if (!connectOptions.port && connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 443 : 80;
      } else if (!connectOptions.port && !connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 6697 : 6667;
      }
      return connectOptions;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CustomServer"]
window._kiwi_exports.components.startups.CustomServer = exports.default ? exports.default : exports;
